import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ItemCategory from './ItemCategory';
import PubSub from "services/PubSub/";
import LoginService from "services/Login/";
import StorageService from 'services/StorageService/';
import DeliverySelector from 'components/Header/DeliverySelector';
import TagManagerService from "services/TagManager";
import { Link } from 'react-router-dom';
import {hasClass, addClass, removeClass} from "utils";
import UserLinks from './UserLinks';
import style from './style.scss';//NOSONAR

let actions = [];

const MobileMenu = (props) => {
    const [isMobile, setMobile] = useState(false);
    const [visible, setVisible] = useState(false);
    const [logged, setIsLogged] = useState(false);
    const [firstName, setFirstName] = useState('');


    useEffect(() => {
        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        Logged();

        actions.push(PubSub.register('logged_in', changeComponent));
        actions.push(PubSub.register('toggle_menu', closeMenu));

        return function cleanup() {
            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
            actions.map(token => PubSub.unregister(token));
        }
    }, []);

    const changeComponent = (payload) => {
        if (payload.actionType === "logged_in")
            setTimeout(() => Logged(), 500);
    };

    const checkViewport = () => {
        if (!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 1120;

        if (currentIsMobile !== isMobile) {
            setMobile(currentIsMobile);
        }
    }

    const Logged = () => {
        const userData = StorageService.getSecureItem('userData');

        setIsLogged(LoginService.isLogged());
        setFirstName(userData.firstName);

    };

    const closeMenuUrl = (tag, url) => {

        if (typeof (url) === 'string') {
            const title_path = url.replace('/', '').replace('_', ' ');
            const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
            TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Superior');
        }

        PubSub.dispatch('toggle_menu');
        TagManagerService.clickHeader(tag, url);
    }

    const openMenu = () => {
        setVisible(!visible);
        PubSub.dispatch('toggle_minicart', { state: false });

        if (window && window.innerWidth <= 860) {

            if (!hasClass(document.querySelector('.new-menu-mobile-button'), "active")) {
                addClass(document.documentElement, 'non-scroll');
            } else {
                removeClass(document.documentElement, 'non-scroll');
            }
        }
    }

    const closeMenu = (payload) => {
        const value = payload.value;
        setVisible(value ? value.state : false );
    }

    const categories = props.categories && props.categories.concat(props.fixedCategories);
    if (!isMobile) return '';

    return (
        <>
            <button className={'new-menu-mobile-button' + (visible ? ' active' : '')} onClick={openMenu} aria-label="Mobile menu button">
                <div className="middle-bar"/>
            </button>
            {visible && <div className={'new-mobile-menu'}>
                <div className="triangle-up"/>
                <div className={'new-menu-mobile-overlay'} onClick={() => setVisible(false)}/>
                <div className={'new-mobile-menu-wrap'} >
                    <span className="user-greet">¡Hola {firstName}!</span>
                    <DeliverySelector/>
                    <UserLinks firstName={firstName} logged={logged} closeMenuUrl={closeMenuUrl}/>
                    <section className="new-mobile-menu-categories">
                        <Link to={"/busca?fq=H%3A3416&nombre_promo=boton-ofertas-home08072019"} className={'mobile-offers-link'} onClick={()=>closeMenuUrl('Ver Ofertas','/_secure/account')}>Ver Ofertas</Link>
                        <ItemCategory categories={categories} />
                    </section>
                    <section className="new-mobile-menu-footer">
                        <a href="tel:600 400 3000" className="new-menu-mobile-phone"><i className="font-icn phone-header" />Llámanos</a>
                    </section>
                </div>
            </div>}
        </>
    )
}

MobileMenu.propTypes = {
    categories: PropTypes.array,
    fixedCategories: PropTypes.array
};

export default MobileMenu;
